function getCurrentPath(location) {
  return location.pathname + location.search + location.hash
}

export default getCurrentPath
